var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isUser && _vm.format.showOwners && _vm.statuses === 1)?_c('div',{staticClass:"owners"},[_c('app-game-item-field-name-owners',{attrs:{"format":_vm.format,"item":_vm.item}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }